const IconCardPlus = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    style={{ minWidth: '40px', minHeight: '40px' }}
  >
    <rect width={40} height={40} fill="#F33" rx={20} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m8 12 1-1h17.985l1 1v8.589h-2v-3.092H10v6.992h12.59v2H9l-1-1V12Zm2 3.497h15.985V13H10v2.497Zm4.314 5.172h-2.76v-2h2.76v2Z"
      clipRule="evenodd"
    />
    <path
      stroke="#fff"
      strokeLinecap="square"
      strokeWidth={2}
      d="M25.127 24.58h3M26.627 23.08v3"
    />
    <circle
      cx={26.627}
      cy={24.58}
      r={4.5}
      stroke="#fff"
      strokeLinejoin="bevel"
      strokeWidth={2}
    />
  </svg>
)
export default IconCardPlus